import React from "react";
import { getTranslations } from "../../Common/utils";

const ProvisionalPointsBadge = ({ variant = "chip", isInverted = false }) => {
  return (
    <div
      className={`si-provisionalPointsBadge si-provisionalPointsBadge--${variant} ${isInverted ? "si-provisionalPointsBadge--inverted" : ""}`}
    >
      <i className="f1i-provipts" aria-hidden="true"></i>
      <span className="si-provisionalPointsBadge__text">
        {getTranslations(
          "match_status_provisional_points",
          "Provisional Points"
        )}
      </span>
    </div>
  );
};

export { ProvisionalPointsBadge };
